import objectPath from "object-path";
import config from "@/common/config/layout.config.json";

// action types
export const SET_LAYOUT_CONFIG = "setLayoutConfig";
export const OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig";
export const SET_LOADING = "setLoading";
export const OVERRIDE_LOADING = "overrideLoading";

// mutation types

export default {
  state: {
    config: config,
    loading: false,
  },
  getters: {
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: (state) => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue);
    },
    loading(state) {
      return state.loading;
    },
  },
  actions: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.commit(OVERRIDE_LAYOUT_CONFIG);
    },
    [SET_LOADING](state, payload) {
      state.commit(SET_LOADING, payload);
    },
  },
  mutations: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload;
    },
    [SET_LOADING](state, payload) {
      state.loading = payload;
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = Object.assign(
        {},
        state.config,
        JSON.parse(localStorage.getItem("config"))
      );
    },
  },
};
